import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import httpClient from '../../../utils/http-client';
import { handleError } from '../../../utils/utils';
import { deleteSubjectFailure, deleteSubjectSuccess } from '../actions';
import subjectsActionTypes from '../types';

export function* deleteSubject({ payload }) {
  const callback = payload.callback;
  delete payload.callback;
  try {
    const response = yield httpClient.delete(`subjects/${payload?.id}`);
    yield put(deleteSubjectSuccess(payload));
    Notify('Subject deleted successfully', { position: 'top-right' });
    callback();
  } catch (error) {
    yield put(deleteSubjectFailure(error?.message));
    const err = handleError(error);
  }
}

export function* onDeleteSubjectStart() {
  yield takeLatest(subjectsActionTypes.DELETE_SUBJECT_START, deleteSubject);
}
